module.exports = __webpack_public_path__ + "teenagers-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-categories/assets/teenagers-logo.png
// module id = 1173
// module chunks = 10